import React, { useEffect, useState } from "react";

import {
  TableCell,
  TableText,
  TableRow,
} from "../../../../../../../Components/FinalTable";

import usePouch from "../../../../../../../Hooks/usePouch";

import { convDate } from "../../../../../../../Util/Time";

import useApp from "../../../../../../../Hooks/useApp";

import TableAction from "./TAction";

import { toTZS } from "../../../../../../../Util/Currency";

const TRow = ({ doc }) => {

  return (
    <>
      <TableRow key={doc.id}>
        <TableCell w={90 / 5.5}>
          <TableText label={doc.procedures.name} />
        </TableCell>
        <TableCell w={90 / 5.5}>
          <TableText label={doc.procedures.code} />
        </TableCell>
        <TableCell w={90 / 5.5}>
          <TableText label={toTZS(doc.procedures.regular_price)} />
        </TableCell>
        <TableCell w={90 / 5.5}>
          <TableText label={convDate(doc.created_at)} />
        </TableCell>
        <TableCell w={90 / 5.5}>
          <TableText label={doc.price} />
        </TableCell>
        <TableCell  w={90 / 8.5}>
          <TableAction doc={doc} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TRow;
